import { Box } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet } from 'react-router'
import { getCurrentCommits } from '../../../../redux/actions/log'
import { updateDisplaytime } from '../../../../redux/actions/userdisplaytime'
import { IRootState } from '../../../../redux/types'
import useScreenWidth from '../../hooks/useScreenWidth'
import { HomeContent } from '../../styles/layouts/MainLayout'
import { clientThemeV5 } from '../../styles/themes/ClientTheme'
import SetQueryParams from '../../utils/SetQueryParams'
import CustomSnackBar from '../CustomSnackBar'
import InternalSlider from '../animations/InternalSlider'
import ClientBreadcumb from '../routes/ClientBreadcumb'
import Footer from './Footer'
import ClientAppBar from './navigation/client/ClientAppBar'

function DetailLayout() {
  const dispatch = useDispatch()
  let isMobile = useScreenWidth(960)

  const { error: errorAuth, msg: msgAuth } = useSelector((state: IRootState) => state.auth)

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(getCurrentCommits())
  }, [])

  useEffect(() => {
    const userdisplaytime = localStorage.getItem('userdisplaytime')
    if (userdisplaytime) {
      const updateUserdisplaytime = JSON.parse(userdisplaytime)
      dispatch(updateDisplaytime(updateUserdisplaytime))
      localStorage.removeItem('userdisplaytime')
    }
  }, [])

  if (localStorage.getItem('login_redirect')) {
    let tmpPath = localStorage.getItem('login_redirect')
    localStorage.removeItem('login_redirect')
    window.location.pathname = tmpPath || '/inicio'
  }

  return (
    <ThemeProvider theme={clientThemeV5}>
      <ClientAppBar />
      <InternalSlider detail={true} />
      {isMobile ? <Box height={60} /> : <ClientBreadcumb />}

      <Box>
        <HomeContent style={{ padding: '0px' }}>
          <Outlet />
        </HomeContent>
      </Box>

      <Footer noMargin={true} />

      <CustomSnackBar errors={[errorAuth]} msgs={[msgAuth]} />

      {/* <ShowMobileBanner /> */}
      <SetQueryParams />
    </ThemeProvider>
  )
}

export default DetailLayout
